import {
  useParams,
  usePathname,
  useSearchParams,
  useRouter,
} from 'next/navigation';

export default function useRoutePath() {
  const router = useRouter();
  const pathname = usePathname();
  const params = useParams();
  const searchParams = useSearchParams();
  const pathnameArr = pathname.split('/');
  const pathLength = pathnameArr.length;
  const currentPathname = pathnameArr.slice(-1)[0];
  const prevPathname = pathnameArr.slice(-2, pathLength - 1)[0];
  const prevPrevPathname = pathnameArr.slice(-2, pathLength - 2)[0];
  const prevPath = pathnameArr.slice(0, pathLength - 1).join('/');
  const prevPrevPath = pathnameArr.slice(0, pathLength - 2).join('/');

  return {
    router,
    currentPathname,
    prevPathname,
    pathname,
    prevPath,
    params,
    searchParams,
    prevPrevPathname,
    prevPrevPath,
  };
}
